import React from 'react';
import { titleCase, formatValue } from '../../base/common/utils';
import Icon from '../../ui/icon';
import placeholderImage from '../../../images/product_placeholder.png';

const Product = ({ data, iconName }) => {
  const icon = iconName ? <Icon iconName={iconName} size={16} /> : null;

  const quantity =
    data.quantity > 1 ? (
      <>
        <Icon iconName="x" size={6} />
        {`${data.quantity} `}
      </>
    ) : null;

  const price = data.unit_price_usd ? (
    <div className="price">
      {formatValue(data.unit_price_usd, 'currency')}
      {quantity}
    </div>
  ) : null;

  function handleImageError(e) {
    e.target.onerror = null;
    e.target.src = placeholderImage;
  }

  return (
    <div className="product">
      <a href={data.store_page_url} target="_blank" rel="noopener noreferrer">
        {icon}
        <div className="img-container">
          <img
            src={data.image_url || placeholderImage}
            alt={data.name}
            onError={e => handleImageError(e, data.image_url)}
          />
        </div>
        <div>
          <div className="brand">{titleCase(data.brand)}</div>
          <div className="name">{titleCase(data.name)}</div>
          {price}
        </div>
      </a>
    </div>
  );
};

export default Product;
